export default "/_assets/twitter_white.0532d2a5.svg"